import { render } from "./TableWithStatus.vue?vue&type=template&id=7fe51bfe&ts=true"
import script from "./TableWithStatus.vue?vue&type=script&lang=ts"
export * from "./TableWithStatus.vue?vue&type=script&lang=ts"

import "./TableWithStatus.vue?vue&type=style&index=0&id=7fe51bfe&lang=css"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__